import React from "react";
import { BusinessCreditReportStatePII, IActiveTaxLine } from "../../../../store/businessCreditReportService/types";
import { toggle } from "../../../../util/common";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const LegalFilingsActiveTaxLines: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-leagal-filings-active-tax-lines"
                            onClick={(e) => toggle("leagal-filings-active-tax-lines-div", "btn-leagal-filings-active-tax-lines")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Active Tax Liens
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Active Tax Liens</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="leagal-filings-active-tax-lines-div"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        {props.reportObject?.businessCompanyReport?.active_tax_liens?.map((taxLine: IActiveTaxLine, index: number) => (
                            <React.Fragment key={`active-tax-line-${index}`}>
                                <div role="grid" className="data-grid row-height-xs " aria-labelledby="btn-leagal-filings-active-tax-lines">
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-tax-lines-date-filed-${index}`}>
                                                Date Filed
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-tax-lines-filing-type-${index}`}>
                                                Filing Type
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-tax-lines-filing-number-${index}`}>
                                                Filing Number
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-tax-lines-date-filed-${index}`}>
                                                {taxLine?.date_filed}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-tax-lines-filing-type-${index}`}>
                                                {taxLine?.filing_type}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-tax-lines-filing-number-${index}`}>
                                                {taxLine?.filing_number}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-tax-lines-amount-${index}`}>
                                                Amount
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-tax-lines-jurisdiction-${index}`}>
                                                Jurisdiction
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`leagal-filings-active-tax-lines-action-type-${index}`}>
                                                Action Type
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-tax-lines-amount-${index}`}>
                                                {taxLine?.amount}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-tax-lines-jurisdiction-${index}`}>
                                                {taxLine?.jurisdiction}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-value" aria-labelledby={`leagal-filings-active-tax-lines-action-type-${index}`}>
                                                {taxLine?.action_type}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LegalFilingsActiveTaxLines;
